"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadMoreNotificationsOnScroll = void 0;
const react_1 = require("react");
const useLoadMoreNotificationsOnScroll = (ref, notificationResponse) => {
    const { fetchNextPage, hasNextPage } = notificationResponse;
    const handleObserver = (0, react_1.useCallback)((entries) => {
        const [target] = entries;
        if (target?.isIntersecting && hasNextPage) {
            fetchNextPage();
        }
    }, [fetchNextPage, hasNextPage]);
    (0, react_1.useEffect)(() => {
        if (ref.current) {
            const element = ref.current;
            const observer = new IntersectionObserver(handleObserver, { threshold: 0 });
            observer.observe(element);
            return () => observer.unobserve(element);
        }
        return undefined;
    }, [fetchNextPage, hasNextPage, handleObserver, ref]);
};
exports.useLoadMoreNotificationsOnScroll = useLoadMoreNotificationsOnScroll;
//# sourceMappingURL=useLoadMoreNotificationsOnScroll.js.map